/**
 * S3 첨�???일 API ?��? 모�??.
 *
 * axios ?��?�?��?�(src/api/index.js)�?공�?�?��? ?��?�??며,
 * ?�증 ?�큰?? index.js???��?�??�?�?��?? ?��??��? Authorization ?��???주�????�?�.
 *
 * path �?�?: {??�???/{?��???/ (?? product/PROD001/, trade-policy/TP_GOLD_BOTH_DEFAULT/)
 */
import api from './index'

/* ================================================================
 * 첨�???일 API
 * ================================================================ */

/**
 * ??일 ??�???
 *
 * @param {string} path - S3 ????경�? prefix (?? product/PROD001/)
 * @param {File} file - ??�???�?� ??일
 * @returns {Promise} { data: { code, objectKey, path, url }, ... }
 */
export function uploadAttachment(path, file) {
  const formData = new FormData()
  formData.append('path', path)
  formData.append('file', file)
  // FormData ??�?� ??Content-Type ??거 ??�?라?��?�? boundary ?��?�??�?� ?��? ?��?
  return api.post('/api/v1/attachment/upload', formData, {
    timeout: 60000,
    transformRequest: [(data, headers) => {
      if (data instanceof FormData && headers && headers['Content-Type']) {
        delete headers['Content-Type']
      }
      return data
    }],
  })
}

/**
 * Presigned URL 조�?? (?��?��?�????.
 *
 * @param {string} objectKey - S3 object key ??체 경�? (?? product/PROD001/abc123-image.png)
 * @returns {Promise} { data: { code, presignedUrl, expiresAt }, ... }
 */
export function getPresignedUrl(objectKey) {
  return api.post('/api/v1/attachment/presigned-url', { path: objectKey })
}

/**
 * ??일 ??�?.
 *
 * @param {string} objectKey - S3 object key ??체 경�?
 * @returns {Promise} { data: { code, message }, ... }
 */
export function deleteAttachment(objectKey) {
  return api.delete('/api/v1/attachment', { params: { path: objectKey } })
}
